// Revival: add to cart from job hub cards without leaving the page.
// Mirrors Horizon's product-form flow: dispatch CartLinesUpdateEvent with a promise,
// POST to cart/add, then resolve with the refreshed cart so the cart icon and drawer update.
import { CartLinesUpdateEvent, CartErrorEvent } from '@shopify/events';

// Listen for the button click (not the form submit) so cart apps such as Rebuy Smart Cart,
// which take over add-to-cart form submits, see a plain AJAX add and open their cart instead.
document.addEventListener('click', async (event) => {
  const button = event.target instanceof Element ? event.target.closest('.rv-card__form button[type="submit"]') : null;
  if (!button) return;
  const form = button.form;
  if (!form) return;
  event.preventDefault();
  event.stopPropagation();
  if (button.disabled) return;

  const label = button ? button.textContent : '';
  if (button) { button.disabled = true; button.textContent = 'Adding...'; }

  const formData = new FormData(form);
  const sectionIds = [...document.querySelectorAll('cart-items-component')]
    .map((el) => el instanceof HTMLElement && el.dataset.sectionId)
    .filter(Boolean);
  if (sectionIds.length) formData.append('sections', sectionIds.join(','));

  const quantity = Number(formData.get('quantity')) || 1;
  const deferred = CartLinesUpdateEvent.createPromise();
  form.dispatchEvent(new CartLinesUpdateEvent({
    action: 'add',
    context: 'product',
    lines: [{ merchandiseId: String(formData.get('id')), quantity }],
    promise: deferred.promise,
  }));

  const done = (text) => {
    if (!button) return;
    button.textContent = text;
    setTimeout(() => { button.textContent = label; button.disabled = false; }, 1800);
  };

  try {
    const res = await fetch(window.Theme?.routes?.cart_add_url || '/cart/add.js', {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' },
      body: formData,
    });
    const data = await res.json();
    if (data.status) {
      form.dispatchEvent(new CartErrorEvent({ error: data.description || data.message || 'Add to cart failed', code: 'INVALID' }));
      deferred.reject(new Error(data.message));
      done(data.description ? 'Unavailable' : 'Try again');
      return;
    }
    const cart = await fetch(`${window.Theme?.routes?.cart_url || '/cart'}.js`, { headers: { Accept: 'application/json' } }).then((r) => r.json());
    deferred.resolve({
      cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
      detail: { items: cart.items, source: 'revival-quick-add', sourceId: form.id || 'rv', itemCount: quantity, sections: data.sections, didError: false },
    });
    done('Added');
  } catch (error) {
    console.error('[revival-quick-add]', error);
    deferred.reject(error);
    window.location.href = (window.Theme?.routes?.cart_url || '/cart'); // let the shopper see the cart state
  }
});
